import React, {Component} from 'react';
import qs from 'qs';
import {Header, Item, Modal} from 'semantic-ui-react';
import produce from 'immer';
import {Redirect} from 'react-router-dom';

import {SEARCH_KEYS, SEARCH_KEY_HEADERS} from '../../constants';
import searchImage from '../assets/search.svg';
import epicorApi from '../../store/services/epicor';
import FormContainer from '../form-components/FormContainer';
import SerialTable from '../components/SerialTable';
import OrderTable from '../components/OrderTable';
import PartsTable from '../components/PartsTable';

const searchKeyMap = {
  [SEARCH_KEYS.SERIAL_NUMBER]: epicorApi.searchBySerialNumber,
  [SEARCH_KEYS.PART_NUMBER]: epicorApi.searchByPartNumber,
  [SEARCH_KEYS.PO_NUMBER]: epicorApi.searchByPurchaseOrderNumber,
};

class SearchResults extends Component {
  state = {
    loading: false,
    searchLimitExceeded: false,
    result: undefined,
    error: undefined,
  };

  _mutate = (draftFn, cb) => {
    this.setState(produce(draftFn), cb);
  };

  componentDidMount() {
    this._handleSearch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.search !== this.props.location.search) {
      this._handleSearch();
    }
  }

  _getQueryParams = () => qs.parse(this.props.location.search.substr(1));

  _handleSearch = async () => {
    const queryParams = this._getQueryParams();
    const {key, query} = queryParams;
    const searchAction = searchKeyMap[key];

    try {
      this.setState({loading: true});
      const {result} = await searchAction(query);
      this.setState({result});
    } catch (error) {
      if (
        error.errors &&
        error.errors[0].errorMessage === '[SEARCH_LIMIT_EXCEEDED]'
      ) {
        this.setState({searchLimitExceeded: true});
      } else {
        alert(error.errors ? error.errors[0].errorMessage : 'Error Searching');
      }
      this.setState({error, result: []});
    } finally {
      this.setState({loading: false});
    }
  };

  render() {
    const {loading, result, searchLimitExceeded} = this.state;
    const queryParams = this._getQueryParams();

    if (!queryParams.query || !queryParams.key) {
      return <Redirect to="/" />;
    }

    const rowRenderFnMap = {
      [SEARCH_KEYS.PO_NUMBER]: () => <OrderTable orders={result} />,
      [SEARCH_KEYS.PART_NUMBER]: () => <PartsTable parts={result} />,
      [SEARCH_KEYS.SERIAL_NUMBER]: () => <SerialTable serialNumbers={result} />,
    };

    const renderFn = rowRenderFnMap[queryParams.key];

    return (
      <FormContainer loading={loading} className="search-results">
        {result && (
          <Header as="h1">
            {SEARCH_KEY_HEADERS[queryParams.key]} Search Results (
            {result.length})
            <Header.Subheader>
              Search Term: {queryParams.query}
            </Header.Subheader>
          </Header>
        )}
        {!!result && result.length === 0 && (
          <Item.Group>
            <Item>
              <Item.Image size="mini" src={searchImage} />
              <Item.Content verticalAlign="middle">
                <strong>No Results Found </strong>
                <div>
                  <small>Try refining your search</small>
                </div>
              </Item.Content>
            </Item>
          </Item.Group>
        )}

        {result && result.length > 0 && renderFn()}
        <Modal
          open={searchLimitExceeded}
          onClose={() => this.setState({searchLimitExceeded: false})}
          centered={false}
          size="tiny"
        >
          <Modal.Content>
            <Header
              size="large"
              textAlign="center"
              style={{
                fontWeight: 'normal',
                borderBottom: 'solid 2px #DFAE38',
                display: 'inline-block',
              }}
            >
              Search Limit Exceeded
            </Header>
            <p>
              Sorry, you have exceeded your daily search limit. Please try again
              tomorrow to continue searching. If you believe you have received
              this message in error, please contact us at{' '}
              <a href="mailto:portalsupport@mmvalve.com">
                portalsupport@mmvalve.com
              </a>
              .
            </p>
          </Modal.Content>
        </Modal>
      </FormContainer>
    );
  }
}

export default SearchResults;
